import sage300AdapterService from '@/Services/sage300AdapterService';

/**
 * Sage 300 Sync Module
 * Purpose: Trigger adapter-side sync jobs for items and stock quantities.
 * All actions require Sage 300 integration to be active.
 */

function normalizeSyncPayload(payload = {}) {
    const mode = String(payload.mode || '').toLowerCase();
    const fullSync = payload.fullSync !== undefined ? Boolean(payload.fullSync) : (mode !== 'incremental');

    return {
        fullSync,
        fromDate: payload.fromDate || payload.updatedSince || undefined,
        batchSize: payload.batchSize || payload.pageSize || undefined,
        dryRun: payload.dryRun === true
    };
}

export default {
    namespaced: true,
    actions: {
        async syncItems({ rootGetters }, payload = {}) {
            const isSage300Integrated = rootGetters['integrations/sage300/isSage300Integrated'];
            if (!isSage300Integrated) {
                console.warn('Cannot sync items: Sage 300 not integrated');
                return { success: false, message: 'Sage 300 not integrated' };
            }

            try {
                const apiKey = rootGetters['integrations/sage300/sage300ApiKey']
                    || (await this.dispatch('integrations/sage300/fetchSage300ApiKey'));

                if (!apiKey) {
                    throw new Error('No Sage 300 API key available');
                }

                const result = await sage300AdapterService.startSage300Sync('/sync/items', apiKey, normalizeSyncPayload(payload));
                console.log('Sage 300 items sync completed:', result);
                return result;
            } catch (error) {
                console.error('Error syncing Sage 300 items:', error);
                throw error;
            }
        },

        async syncStockQty({ rootGetters }, payload = {}) {
            const isSage300Integrated = rootGetters['integrations/sage300/isSage300Integrated'];
            if (!isSage300Integrated) {
                console.warn('Cannot sync stock quantities: Sage 300 not integrated');
                return { success: false, message: 'Sage 300 not integrated' };
            }

            try {
                const apiKey = rootGetters['integrations/sage300/sage300ApiKey']
                    || (await this.dispatch('integrations/sage300/fetchSage300ApiKey'));

                if (!apiKey) {
                    throw new Error('No Sage 300 API key available');
                }

                const result = await sage300AdapterService.startSage300Sync('/sync/stock-qty', apiKey, normalizeSyncPayload(payload));
                console.log('Sage 300 stock quantity sync completed:', result);
                return result;
            } catch (error) {
                console.error('Error syncing Sage 300 stock quantities:', error);
                throw error;
            }
        },

        async syncCustomers({ rootGetters }, payload = {}) {
            const isSage300Integrated = rootGetters['integrations/sage300/isSage300Integrated'];
            if (!isSage300Integrated) {
                console.warn('Cannot sync customers: Sage 300 not integrated');
                return { success: false, message: 'Sage 300 not integrated' };
            }

            try {
                const apiKey = rootGetters['integrations/sage300/sage300ApiKey']
                    || (await this.dispatch('integrations/sage300/fetchSage300ApiKey'));

                if (!apiKey) {
                    throw new Error('No Sage 300 API key available');
                }

                const result = await sage300AdapterService.startSage300Sync('/sync/customers', apiKey, normalizeSyncPayload(payload));
                console.log('Sage 300 customers sync completed:', result);
                return result;
            } catch (error) {
                console.error('Error syncing Sage 300 customers:', error);
                throw error;
            }
        },
    },
};
